function imagesCollectionPage() {
  
    var $lista = $("ul#gf-products");
    var $elementosLi = $lista.find("li.grid__item");
    var $bannerOne = $('div.section-multibanners-collection').attr('data-banner-1');
    var $bannerTwo = $('div.section-multibanners-collection').attr('data-banner-2');
    var $linkOne = $('div.section-multibanners-collection').attr('data-link-1');
    var $linkTwo = $('div.section-multibanners-collection').attr('data-link-2');

  
    var $divNuevoOne = null;
    if ($bannerOne) {
        $divNuevoOne = $('<li class="grid__item imagen-collection-page__middle imagen-collection-page__middle--1">' +
              '<div class="container-imagen">' +
                ($linkOne == undefined ? 
                  '<img src="' + $bannerOne + '">' :
                  '<a target="_blank" href="' + $linkOne + '">' +
                    '<img src="' + $bannerOne + '">' +
                  '</a>'
                ) +
              '</div>' +
            '</li>');
    }

    var $divNuevoTwo = null;
    if ($bannerTwo) {
        $divNuevoTwo = $('<li class="grid__item imagen-collection-page__middle imagen-collection-page__middle--2">' +
              '<div class="container-imagen">' +
                ($linkTwo == undefined ? 
                  '<img src="' + $bannerTwo + '">' :
                  '<a target="_blank" href="' + $linkTwo + '">' +
                    '<img src="' + $bannerTwo + '">' +
                  '</a>'
                ) +
              '</div>' +
            '</li>');
    }
  
    if($elementosLi.length <= 4) {
      $('.imagen-collection-page__middle').remove();
    } else if ($elementosLi.length >= 5 && $elementosLi.length <= 9) {
        if ($divNuevoOne && $('.imagen-collection-page__middle img[src="' + $bannerOne + '"]').length === 0) {
            $elementosLi.eq(3).after($divNuevoOne);
        } else {
            $('.imagen-collection-page__middle--2').remove();
        }
    } else if ($elementosLi.length >= 10) {

          console.log($divNuevoOne);
          console.log($divNuevoTwo);
      
        if ($divNuevoOne && $('.imagen-collection-page__middle img[src="' + $bannerOne + '"]').length === 0) {
            $elementosLi.eq(3).after($divNuevoOne);
            console.log('SE AGREGA EL BANNER PRIMARIO')
        }

        if ($divNuevoTwo && $('.imagen-collection-page__middle img[src="' + $bannerTwo + '"]').length === 0) {
            $elementosLi.eq(8).after($divNuevoTwo);  
            console.log('SE AGREGA EL BANNER SECUNDARIO')
        }
    }
};






const interval = setInterval(() => {
const containerGloboApp = document.querySelector('ul#gf-products[data-globo-filter-items]');
if (containerGloboApp) {
    clearInterval(interval);
    console.log('✅ Contenedor de Globo encontrado (con retry). Observando cambios...');
    imagesCollectionPage();

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0) {
          console.log('🔄 Cambio detectado en el contenedor de Globo. Reevaluando productos...');
          imagesCollectionPage();
        }
      });
    });

    observer.observe(containerGloboApp, {
      childList: true,
      subtree: true
    });
  }
}, 300); // Reintenta cada 300ms hasta encontrarlo